import {combineReducers} from 'redux';
import system from './systemReducer';
import app from './appReducer';
import account from './accountCreationReducer';
import mailingInformation from './mailingInformationReducer';
import vatInformation from './vatInformationReducer';
import purchaseOrder from './purchaseOrderReducer';
import softwareDetails from './softwareDetailsReducer';
import currency from './currencyReducer';
import userInfoDetails from './userInfoReducer';
import companyLocation from './companyLocationReducer';
import gqlEligibility from './gqlEligibilityReducer';
import masterBrand from './masterBrandReducer';
import informationPage from './informationPageReducer';
import basicInformation from './basicInformationReducer';
import help from './helpReducer';
import propertyCount from './propertyCountReducer';
import abacusReducer from './abacusReducer';
import landingPage from './landingPageReducer';
import reviewPage from './reviewPageReducer';
import webFormPage from './webFormPageReducer';
import billingSetup from "./billingSetupAppReducer";
import multipleAccounts from './multipleAccountsReducer';
import confirmBrand from './confirmBrandReducer';
import businessModel from './businessModelReducer';
import brandDetermination from './brandDeterminationReducer'
import payoutDetails from './payoutDetailsReducer'
import confirmationPage from './confirmationPageReducer';
import discontinuedBrand from './discontinuedBrandReducer';
import pmisBusinessModelSwitch from './pmisBusinessModelSwitchReducer';
import hasPpsListings from './hasPpsListingsReducer';

/**
 * Connect reducers to the redux store.
 */
const reducers = combineReducers({
    system,
    app,
    account,
    purchaseOrder,
    softwareDetails,
    mailingInformation,
    currency,
    userInfoDetails,
    companyLocation,
    masterBrand,
    gqlEligibility,
    informationPage,
    help,
    vatInformation,
    basicInformation,
    propertyCount,
    abacusReducer,
    landingPage,
    reviewPage,
    webFormPage,
    billingSetup,
    multipleAccounts,
    confirmBrand,
    businessModel,
    brandDetermination,
    payoutDetails,
    confirmationPage,
    discontinuedBrand,
    pmisBusinessModelSwitch,
    hasPpsListings
});

export default reducers;
